export default function IconBullet({ className }: { className?: string }) {
    return (
        <svg
            className={className}
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            width="398.000000pt"
            height="300.000000pt"
            viewBox="0 0 398.000000 300.000000"
            preserveAspectRatio="xMidYMid meet"
        >
            <g
                transform="translate(0.000000,300.000000) scale(0.100000,-0.100000)"
                fill="none"
                stroke="none"
            >
                <path
                    fill="currentColor"
                    d="M430 1520 l0 -1110 344 0 344 0 4 53 c1 28 2 64 0 79 l-3 28 -240 0
-239 0 0 950 0 950 239 0 239 0 4 64 c1 35 2 71 0 80 -3 14 -39 16 -348 16
l-344 0 0 -1110z"
                />
                <path
                    fill="currentColor"
                    d="M2820 2550 l0 -80 240 0 240 0 0 -950 0 -950 -240 0 -240 0 0 -80 0
-80 350 0 350 0 0 1110 0 1110 -350 0 -350 0 0 -80z"
                />
                <path
                    fill="currentColor"
                    d="M1904 1791 c-101 -25 -196 -115 -229 -219 -36 -109 8 -262 94 -333
67 -55 118 -73 211 -73 100 -1 159 22 225 88 65 65 89 126 89 226 1 79 -2 90
-34 149 -70 129 -215 195 -356 162z"
                />
            </g>
        </svg>
    )
}
